// Extract filtering logic for easier testing
export interface Project {
  id: string;
  title: string;
  slug: string;
  description: string;
  status: string;
  startDate: string;
  endDate: string | null;
  technologyGroups: Array<{
    category: string;
    technologies: Array<{ name: string; description: string }>;
  }>;
  tags: Array<{ name: string }>;
}

export function filterProjectsByStatus(projects: Project[], status: string | null): Project[] {
  if (!status) return projects;
  return projects.filter(project => project.status === status);
}

export function filterProjectsBySearch(projects: Project[], search: string): Project[] {
  if (!search.trim()) return projects;
  
  const searchLower = search.toLowerCase();
  return projects.filter(project =>
    project.title.toLowerCase().includes(searchLower) ||
    project.description.toLowerCase().includes(searchLower) ||
    project.technologyGroups.some(group => 
      group.technologies.some(tech => tech.name.toLowerCase().includes(searchLower))
    ) ||
    project.tags.some(tag => tag.name.toLowerCase().includes(searchLower))
  );
}

export function filterProjects(
  projects: Project[], 
  search: string, 
  statusFilter: string | null
): Project[] {
  let filtered = filterProjectsByStatus(projects, statusFilter);
  filtered = filterProjectsBySearch(filtered, search);
  return filtered;
}